import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateUsernameRPC } from "./updateUsernameRPC";

export class UpdateUsernameRPCClientImpl extends UpdateUsernameRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateUsernameRPC.Request): Promise<LeoRPCResult<UpdateUsernameRPC.Response, UpdateUsernameRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "profile/UpdateUsername",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateUsernameRPC.ResponseDTO,
      UpdateUsernameRPC.Errors.ErrorsDTO,
      UpdateUsernameRPC.Response,
      UpdateUsernameRPC.Errors.Errors
    >(
      response,
      "profile/UpdateUsername",
      UpdateUsernameRPC.Response.fromDTO,
      UpdateUsernameRPC.Errors.fromDTO
    );
  }
}
